import {get} from "lodash"

import {Tenant, User, Business, UnauthedBusiness, UserTeamAssignment, ProductPermissions, DealsPackage} from "@irati/types"
import {CurrencyType} from "@irati/payments/enums"

import {isGlobalAdmin as isGlobalAdminHelper} from "@irati/identity/helpers/user/role"
import AuthService from "./streams/auth"
import UnauthedService from "./streams/unauthed"

type AppsTruthy = boolean | object | null
function apps(): ProductPermissions
function apps(key: string): AppsTruthy
function apps(key?: string) {
  try {
    const auth = AuthService.get()

    return key?.length ? get(auth.productPermissions, key, false) : auth.productPermissions
  } catch (e) {
    return false
  }
}

const user = (): User => {
  const auth = AuthService.get()

  return auth.user
}

const userTenant = (key = ""): Tenant => {
  const auth = AuthService.get()

  return key.length ? get(auth.userTenant, key, false) : auth.userTenant
}

const business = (): Business => {
  const auth = AuthService.get()

  return auth.business
}

const teamAssignments = (): UserTeamAssignment[] => {
  const auth = AuthService.get()

  return auth.userTeamAssignments
}

const dealPackage = (): DealsPackage => {
  const auth = AuthService.get()

  return auth.dealPackage
}

const unAuthedBusiness = (): UnauthedBusiness => {
  const auth = UnauthedService.get()

  return auth.unauthedBusiness
}

const userLocale = (): string => {
  // Forcing all users to en-GB language - inline with graph changes
  return "en-GB"
}

const defaultUserCurrency = (): string => {
  // This method should not be driving any business logic anymore - to be removed
  switch (userLocale()) {
    case "fr-FR":
      return CurrencyType.EUR
    case "en-AU":
      return CurrencyType.AUD
    case "en-GB":
    default:
      return CurrencyType.GBP
  }
}

const isLoggedIn = (): boolean => {
  try {
    AuthService.get()
    return true
  } catch (e) {
    return false
  }
}

const isGlobalAdmin = (): boolean => {
  try {
    return isGlobalAdminHelper(business(), user())
  } catch (e) {
    return false
  }
}

const isUserGhost = (): boolean => {
  return !!apps("ghost.isGhost")
}

const userOnboarding = () => {
  return isLoggedIn() ? AuthService.get().userOnboarding : undefined
}

/** @deprecated please use `useAuth*` hooks */
const authentication = {
  // user related
  user,
  userLocale,
  business,
  teamAssignments,
  unAuthedBusiness,
  defaultUserCurrency,
  isGlobalAdmin,
  dealPackage,
  userOnboarding,

  // meta
  isLoggedIn,
  isUserGhost,
  apps,

  // to be deprecated
  userTenant
}

export default authentication
